/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {
    SAVE: 'Guardar',
    SUBMIT: 'Enviar'
  },
  ERROR: {
    CANCEL_COUNTERPART: 'Error al cancelar la contraprestación',
    COUNTERPART_DETAILS_SUBMIT: 'Error al enviar la contraprestación',
    DELETE_ATTACHMENT: 'Error al eliminar el archivo adjunto',
    DELETE_LINK: 'Error al eliminar el enlace',
    ERROR: 'Error',
    FILE_SIZE: 'El archivo debe tener como máximo 8 MB',
    MAX_FILES_UPLOAD: 'No se pueden cargar más de 8 MB a la vez',
    PUBLISHED_AT_ERROR: 'Fecha de publicación obligatoria'
  },
  HEADER: {
    APPROVED_BY: 'Aprobado por',
    ATTACHMENT: 'Archivos adjuntos',
    COMMENT: 'Comentarios',
    CONFIRMATION_DATE: 'Confirmación',
    CURRENT_PARTNER_TASKS: 'Afiliado actual',
    DESCRIPTION: 'Descripción',
    END_DATE: 'Fecha de finalización',
    LINK: 'Enlaces',
    MANAGER_COMMENT: 'Comentarios del gestor',
    MONTH: 'Mes',
    PERIODICITY: 'Periodicidad',
    PREVIOUS_PARTNER_TASKS: 'Afiliado anterior',
    REQUIRED: 'Obligatorio',
    START_DATE: 'Fecha de inicio',
    STATE: 'Estado',
    SUBMISSION_DATE: 'Envío'
  },
  LABEL: {
    ATTACHMENTS: 'Archivos adjuntos',
    ATTACHMENTS_UPLOADED: 'Archivos adjuntos cargados',
    CANCEL_COUNTERPART: 'Cancelar',
    CLOSE: 'Cerrar',
    COMMENT: 'Comentarios',
    CONFIRM: 'Confirmar',
    DESCRIPTION: 'Descripción',
    FILTER_MONTH_APR: 'Abril',
    FILTER_MONTH_AUG: 'Agosto',
    FILTER_MONTH_DEC: 'Diciembre',
    FILTER_MONTH_FEB: 'Febrero',
    FILTER_MONTH_JAN: 'Enero',
    FILTER_MONTH_JUL: 'Julio',
    FILTER_MONTH_JUN: 'Junio',
    FILTER_MONTH_MAR: 'Marzo',
    FILTER_MONTH_MAY: 'Mayo',
    FILTER_MONTH_NOV: 'Noviembre',
    FILTER_MONTH_OCT: 'Octubre',
    FILTER_MONTH_SEP: 'Septiembre',
    LINK: 'Enlace',
    LINKS: 'Enlaces',
    LINKS_UPLOADED: 'Enlaces subidos',
    MONTH: 'Mes',
    PUBLISHED_AT: 'Fecha de publicación',
    STATE: 'Estado',
    SUBMIT_COUNTERPART: 'Enviar',
    YEAR: 'Año'
  },
  SENTENCE: {
    CANCEL_COUNTERPART_TEXT:
      '¿Realmente deseas cancelar el envío la contraprestación?',
    CONFIRM_SUBMIT_COUNTERPART_TEXT:
      '¿Realmente deseas enviar la contraprestación?',
    NO_ROWS_ATTACHMENT: 'No hay archivos adjuntos'
  },
  SUCCESS: {
    ATTACHMENT_DELETED: 'Archivos adjuntos eliminados',
    CANCEL_COUNTERPART: 'Contraprestación cancelada',
    COUNTERPART_DETAILS_SUBMIT:
      'Detalles de la contrapartida enviados correctamente',
    LINK_DELETED: 'Enlace eliminado',
    SUCCESS: 'Acción realizada correctamente'
  },
  TOOLTIP: {
    ADD_LINK: 'Agregar enlace',
    APPROVED_BY: 'Aprobado por',
    ATTACHMENT: 'Archivos adjuntos',
    COMMENT: 'Comentarios',
    CONFIRMATION_DATE: 'Fecha de confirmación',
    CURRENT_PARTNER_TASKS:
      'N.º de registros del período actual que debe enviar el afiliado',
    DESCRIPTION: 'Descripción',
    END_DATE: 'Fecha de finalización',
    LINK: 'Enlaces',
    MANAGER_COMMENT: 'Comentarios del gestor',
    MONTH: 'Mes',
    PERIODICITY: 'Periodicidad',
    PREVIOUS_PARTNER_TASKS:
      'N.º de registros del período anterior que debe enviar el afiliado',
    REMOVE_LINK: 'Eliminar enlace',
    REQUIRED: 'Obligatorio',
    START_DATE: 'Fecha de inicio',
    STATE: 'Estado',
    SUBMISSION_DATE: 'Fecha de envío'
  }
};
